var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckboxButton',{attrs:{"checked":_vm.item.response},on:{"input":_vm.valueChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }